import { Link } from 'react-router-dom';

export default function Footer() {
  const footerLinks = {
    快速导航: [
      { label: '首页', to: '/' },
      { label: '玩法分类', to: '/category/guobiao-majiang' },
      { label: '攻略文章', to: '/article/majiang-rumen-jiaocheng' },
      { label: '关于我们', to: '/about' },
    ],
    热门玩法: [
      { label: '国标麻将', to: '/category/guobiao-majiang' },
      { label: '四川麻将', to: '/category/sichuan-majiang' },
      { label: '广东麻将', to: '/category/guangdong-majiang' },
      { label: '血流成河', to: '/category/xueliu-chenghe' },
    ],
    帮助支持: [
      { label: '新手教程', to: '/article/majiang-rumen-jiaocheng' },
      { label: '常见问题', to: '/#faq' },
      { label: '联系我们', to: '/about#contact' },
    ],
  };

  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full px-4 md:px-6 lg:px-8 py-12 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="flex items-center gap-2 cursor-pointer mb-4">
              <span className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-gamepad-line text-background-50 text-lg"></i>
              </span>
              <span className="text-lg font-heading font-bold text-foreground-900 whitespace-nowrap">
                麻将在线玩
              </span>
            </Link>
            <p className="text-sm text-foreground-500 leading-relaxed max-w-xs">
              免费在线麻将游戏平台，无需下载安装，打开浏览器即可畅玩。国标麻将、四川麻将等多种玩法任你选。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-200/70 text-foreground-500 hover:text-primary-500 hover:bg-primary-100/70 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-200/70 text-foreground-500 hover:text-primary-500 hover:bg-primary-100/70 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-200/70 text-foreground-500 hover:text-primary-500 hover:bg-primary-100/70 transition-colors cursor-pointer" aria-label="QQ">
                <i className="ri-qq-line"></i>
              </a>
            </div>
          </div>

          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h3 className="text-sm font-semibold text-foreground-800 mb-4">{title}</h3>
              <ul className="flex flex-col gap-2.5">
                {links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; {new Date().getFullYear()} 麻将在线玩 版权所有 | 麻将在线玩免费网页版
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-400 hover:text-foreground-600 transition-colors cursor-pointer">隐私政策</a>
            <a href="#" className="text-xs text-foreground-400 hover:text-foreground-600 transition-colors cursor-pointer">服务条款</a>
          </div>
        </div>
      </div>
    </footer>
  );
}